export default __webpack_public_path__ + "static/media/AccessRestricted.7e9ddefe.png";